import { CSSProperties } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { ptBR } from '../../i18n/pt-BR';

const linkStyle: CSSProperties = { marginRight: 16, color: '#137333' };

export default function AdminLayout() {
  const { user, logout } = useAuth();

  return (
    <main
      style={{
        fontFamily: 'system-ui, sans-serif',
        maxWidth: 960,
        margin: '2rem auto',
        padding: '0 1rem',
      }}
    >
      <header
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 24,
        }}
      >
        <h1 style={{ margin: 0 }}>{ptBR.admin.title}</h1>
        <div>
          <span style={{ marginRight: 16, color: '#666' }}>{user?.name}</span>
          <button onClick={() => void logout()}>{ptBR.auth.logout}</button>
        </div>
      </header>
      <nav style={{ marginBottom: 24, borderBottom: '1px solid #ddd', paddingBottom: 12 }}>
        <NavLink to="/admin/tenants" style={linkStyle}>
          {ptBR.admin.nav.tenants}
        </NavLink>
        <NavLink to="/admin/users" style={linkStyle}>
          {ptBR.admin.nav.users}
        </NavLink>
        <NavLink to="/admin/memberships" style={linkStyle}>
          {ptBR.admin.nav.memberships}
        </NavLink>
      </nav>
      <Outlet />
    </main>
  );
}
